import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';

const PorQueEsteTaller = () => {
  const theme = useTheme();

  return (
    <Box>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              width: '100%',
              maxWidth: 320,
              mx: { xs: 'auto', md: 0 },
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: 3,
            }}
          >
            <Box
              component="img"
              src="/images/Online Search.png"
              alt="Online search - encuentra tu camino en el contenido digital"
              sx={{
                width: '100%',
                height: 'auto',
                display: 'block',
                objectFit: 'cover',
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography
            sx={{ textTransform: 'uppercase', fontWeight: 700 }}
            variant="overline"
            color="primary"
            display="block"
            gutterBottom
          >
            ¿Por qué este taller es para ti?
          </Typography>
          <Box
            component={Typography}
            fontWeight={700}
            variant="h5"
            gutterBottom
            color={theme.palette.text.primary}
          >
            Pasar de una idea a un streaming profesional puede ser un laberinto técnico.
          </Box>
          <Typography variant="body1" color="textSecondary" paragraph>
            <strong>TNO Network</strong> ha diseñado este mapa de ruta junto a dos expertas de la comunicación para que aprendas a producir contenido que no solo se vea, sino que <strong>conecte y se viralice</strong>.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PorQueEsteTaller;
